import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { I as InnerSwitch } from './InnerSwitch/InnerSwitch-CTGdFP_Q.js';
import { a as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const LabelCenterer = /*#__PURE__*/styled('label').withConfig({
  componentId: "sc-storm-ui-40019274__sc-1meqyfg-0"
})(["font:", ";padding:0;color:", ";cursor:", ";", ""], ({
  theme
}) => theme.font.text.base.default, ({
  disabled,
  theme
}) => disabled ? theme.text.color.unavailable : theme.text.color.secondary, ({
  disabled
}) => disabled ? 'not-allowed' : 'pointer', isMobile(css(["font:", ""], ({
  theme
}) => theme.font.text.base.mobile)));
const LabelArea = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40019274__sc-1meqyfg-1"
})(["display:inline-flex;align-items:start;margin-inline-start:6px;", ""], isMobile(css(["margin-inline-start:14px"])));
const SwitchContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40019274__sc-1meqyfg-2"
})(["display:inline-flex;align-items:center;"]);
const Switch = ({
  disabled = false,
  onChange = noop,
  id,
  label,
  renderLabelEnd,
  small = false,
  taktId,
  taktValue,
  toggled = false,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('switch')
}, ({
  getDataTaktAttributes
}) => label ? /*#__PURE__*/React__default.createElement(SwitchContainer, null, /*#__PURE__*/React__default.createElement(InnerSwitch, _extends({}, getDataTaktAttributes(), rest, {
  id: id,
  disabled: disabled,
  onChange: onChange,
  small: small,
  toggled: !!toggled
})), /*#__PURE__*/React__default.createElement(LabelArea, null, /*#__PURE__*/React__default.createElement(LabelCenterer, _extends({}, getDataTaktAttributes({
  taktIdSuffix: 'label'
}), {
  htmlFor: id,
  disabled: disabled
}), label), renderLabelEnd && renderLabelEnd)) : /*#__PURE__*/React__default.createElement(InnerSwitch, _extends({}, getDataTaktAttributes(), rest, {
  id: id,
  disabled: disabled,
  onChange: onChange,
  small: small,
  toggled: !!toggled
})));

export { Switch as S };
//# sourceMappingURL=Switch-BmRgUQTq.js.map
